import type { DataTableSortState } from "@carbon6/c6-frontend-design";

// 서버 정렬 source 가 공유하는 "같은 정렬인가" 판정의 단일 소스.
//
// DataTable 은 마운트 시에도 활성 정렬을 통지한다(초기값 null). source 가 no-op 통지와 실제
// 정렬 변경을 구분하지 못하면 첫 페이지를 한 번 더 받는다. 페이지 캐시 키에도 같은 서명을 쓴다.
export function sortSignature(sort: DataTableSortState | null): string {
  return sort === null ? "" : `${sort.columnKey}:${sort.direction}`;
}
